export default __webpack_public_path__ + "static/media/smart.860d8e2d.svg";